export const initialState = (document, owners = [], phases = []) => {
	if (document) {
		let ownerId = "";
		if (document.owner && document.owner.id) {
			ownerId = document.owner.id;
		} else if (document.ownerId) {
			ownerId = document.ownerId;
		} else if (document.ownerName && owners.length > 0) {
			const matchingOwner = owners.find(
				(o) => o.displayName === document.ownerName || o.name === document.ownerName
			);
			ownerId = matchingOwner?.id || "";
		}

		let phaseId = "";
		if (document.phase && document.phase.id) {
			phaseId = document.phase.id;
		} else if (document.phaseId) {
			phaseId = document.phaseId;
		} else if (document.phaseName && phases.length > 0) {
			const matchingPhase = phases.find((p) => p.name === document.phaseName);
			phaseId = matchingPhase?.id || "";
		}

		return {
			name: document.name || "",
			ref: document.ref || "",
			ownerId,
			format: document.format || "",
			type: document.type || "",
			thematics: (document?.thematic && document.thematic.map((c) => c.id)) || [],
			phaseId,
		};
	}
	return { name: "", ref: "", format: "", type: "", thematics: [], phaseId: "", ownerId: "" };
};

export const initialErrorState = { name: false, ref: false, type: false, format: false, owner: false };
